// extracted by mini-css-extract-plugin
module.exports = {"container":"qrcodes_container__1xflL","backButton":"qrcodes_backButton__3VGsG"};